import { PropTypes } from 'base/react-libs';

const TasksToolbar = ({ numTasks = 0 }) => {
  return (
    <div className="tasks-toolbar space-between">
      <strong style={{ margin: 0, alignSelf: 'end' }}>
        {numTasks} Total {numTasks === 1 ? 'Task' : 'Tasks'}
      </strong>
    </div>
  );
};

TasksToolbar.propTypes = {
  numTasks: PropTypes.number,
};

export default TasksToolbar;
